import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { NotificationsPropType } from "models/propTypes/notificationsPropTypes";
import { TranslationKeys } from "translations";
import { CommonConstants } from "utils/constants";
//#endregion
//#region components
import { Chip, Grid } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import { WelcomeGuideTooltip } from "components/welcomeGuide";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const Notifications: React.FC<NotificationsPropType> = (props) => {
  const shownHelps = useSelector((state: AppState) =>
    state.auth.profileToggles.shownHelps?.includes(CommonConstants.WelcomeGuideId)
  );
  const shownIntroductions = useSelector((state: AppState) =>
    state.auth.profileToggles.shownIntroductions?.includes(CommonConstants.WelcomeGuideId)
  );

  const notificationChip = () => {
    return props.count !== undefined ? (
      <Chip
        label={props.count}
        clickable={props.count > 0}
        onClick={props.toggleNotifications}
        className={cssExports.notificationChip}
      />
    ) : (
      <Skeleton variant="circular" width="40px" height="40px" />
    );
  };

  return (
    <Grid className={cssExports.layoutChips}>
      {shownIntroductions && !shownHelps ? (
        <WelcomeGuideTooltip
          open={true}
          placement="bottom-end"
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.NotificationHelpText)}
          content={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.NotificationContentHelpText)}
        >
          {notificationChip()}
        </WelcomeGuideTooltip>
      ) : (
        <>{notificationChip()}</>
      )}
    </Grid>
  );
};

export default Notifications;
